import PostCard, {
  PostCardCatalogDndPrefix,
  PostCardFormDndPrefix,
  PostCardHubDndPrefix,
  PostCardHubPageDndPrefix,
  PostCardMediaDndPrefix,
  PostCardZnglistDndPrefix,
  type PickFromPostCardTypes,
} from '@/Components/posts/ui/posts-card';

import type { ZnglyVideo } from '@/graphql/types';
import ListViewItemWrapper, { SORTABLE_LIST_ITEM_DND_PREFIX } from '@/inertia/Shared/Catalog/ListItem';
import {
  DragOverlay,
  type DragStartEvent,
  type DropAnimation,
  defaultDropAnimationSideEffects,
  useDndMonitor,
} from '@dnd-kit/core';
import React from 'react';
import {
  type CatalogListItemNode,
  SORTABLE_ITEM_DND_PREFIX,
  SortableCardItem,
} from '../posts/ui/sortable-card.catalog';

const Template = ({ activeId, activeData }: { activeId: string; activeData: DragStartEvent['active']['data'] }) => {
  if (activeId?.startsWith(PostCardCatalogDndPrefix)) {
    return <PostCard node={activeData?.current as PickFromPostCardTypes<'catalog'>['node']} type="catalog" />;
  }

  if (activeId?.startsWith(PostCardHubDndPrefix)) {
    return <PostCard node={activeData?.current as PickFromPostCardTypes<'hub'>['node']} type="hub" />;
  }

  if (activeId?.startsWith(PostCardHubPageDndPrefix)) {
    return <PostCard node={activeData?.current as PickFromPostCardTypes<'hubPage'>['node']} type="hubPage" />;
  }

  if (activeId?.startsWith(PostCardZnglistDndPrefix)) {
    return <PostCard node={activeData?.current as PickFromPostCardTypes<'znglist'>['node']} type="znglist" />;
  }

  if (activeId?.startsWith(PostCardMediaDndPrefix)) {
    return <PostCard node={activeData?.current as PickFromPostCardTypes<'media'>['node']} type="media" />;
  }

  if (activeId?.startsWith(PostCardFormDndPrefix)) {
    return <PostCard node={activeData?.current as PickFromPostCardTypes<'form'>['node']} type="form" />;
  }

  if (activeId?.startsWith(SORTABLE_LIST_ITEM_DND_PREFIX)) {
    return <ListViewItemWrapper node={activeData?.current?.node as ZnglyVideo} idx={0} />;
  }

  if (activeId?.startsWith(SORTABLE_ITEM_DND_PREFIX)) {
    return <SortableCardItem node={activeData?.current?.node as CatalogListItemNode} />;
  }

  return null;
};

const dropAnimationConfig: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.4',
      },
    },
  }),
};

const DndOverlay = () => {
  const [activeId, setActiveId] = React.useState<string | null>(null);
  const [activeData, setActiveData] = React.useState<DragStartEvent['active']['data'] | null>(null);

  useDndMonitor({
    onDragStart(event) {
      setActiveId(event.active.id?.toString());
      setActiveData(event.active.data);
    },
    onDragEnd() {
      setActiveId(null);
      setActiveData(null);
    },
    onDragCancel() {
      setActiveId(null);
      setActiveData(null);
    },
  });

  return (
    <DragOverlay dropAnimation={dropAnimationConfig}>
      {activeData && activeId ? <Template activeId={activeId} activeData={activeData} /> : null}
    </DragOverlay>
  );
};

export default DndOverlay;
